import 'element-ui/lib/theme-chalk/index.css';
import { 
    Button, 
    Dialog 
  } from 'element-ui';
  // import 'element-ui/lib/theme-chalk/index.css';
import OccSTable from './OccSTable'
const components = [OccSTable,Button,Dialog]
const install = function(Vue,opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
export default {
  install,
  OccSTable
}



// WEBPACK FOOTER //
// ./src/components/index.js